import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { addOutline } from 'ionicons/icons';
import InvoicesTable from './InvoicesTable';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllInvoiceAsync, getAllInvoiceStatusAsync } from '@application/features/invoices/invoiceThunk';
import VnPagination from '@ui/components/VnPagination';
import { useNavigate } from 'react-router-dom';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { clearInvoiceNotes, clearInvoiceWorkOrderNumber } from '@application/features/invoices/invoiceSlice';
const Invoice = () => {
    VnDocumentTitle('Visser Facturen');
    const dispatch = useAppDispatch();
    const { invoices, invoiceRequest } = useAppSelector((state) => state.invoice);
    const [searchInvoiceText, setSearchInvoiceText] = useState('');
    const navigate = useNavigate();
    const handleAddInvoiceClick = () => {
        dispatch(clearInvoiceWorkOrderNumber());
        dispatch(clearInvoiceNotes());
        navigate(`/admin/InvoiceTabs`);
    };
    const defaultSortingCriteria = {
        sortColumnKey: 'created',
        sortDirection: 'desc'
    };
    const defaultInvoiceFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        invoiceNumber: null,
        created: null,
        invoiceDate: null,
        workorderNumber: null,
        debtorName: null,
        workorderDescription: null,
        debtorOrderNumber: null,
        invoiceStatus: null,
        createdBy: null
    };
    const [invoiceFilterValues, setInvoiceFilterValues] = useState(defaultInvoiceFilterValues);
    const onRowClick = (rowId) => {
        window.open(`/admin/InvoiceTabs/${rowId}`, '_blank');
    };
    /* Filtering and Sorting for Invoice */
    useEffect(() => {
        dispatch(getAllInvoiceAsync(invoiceFilterValues));
        dispatch(getAllInvoiceStatusAsync());
    }, []);
    const updateApprovedFilterValues = (newValues) => {
        setInvoiceFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchInvoiceHandler(searchText) {
        updateApprovedFilterValues({ filter: searchText });
        dispatch(getAllInvoiceAsync({ ...invoiceFilterValues, filter: searchText, pageNumber: 1 }));
    }
    function onInvoicesPageChange(pageNumber) {
        updateApprovedFilterValues({ pageNumber });
        dispatch(getAllInvoiceAsync({
            ...invoiceFilterValues,
            pageNumber: pageNumber
        }));
    }
    function InvoiceSortingHandler(data) {
        updateApprovedFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllInvoiceAsync({
            ...invoiceFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function InvoiceFilteringHandler(data) {
        data.pageNumber = 1;
        updateApprovedFilterValues(data);
        dispatch(getAllInvoiceAsync({
            ...invoiceFilterValues,
            ...data
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '2rem'
                }, children: [_jsx("h4", { children: "Facturen" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Facturen', onClick: handleAddInvoiceClick, isDisabled: !handleRolePermission(Permission.FACTUREN, PermissionType.Create) }) })] }), _jsx("div", { className: 'mt-0', children: _jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchInvoiceHandler }), _jsx(InvoicesTable, { invoices: invoices?.items, onRowClick: onRowClick, onSorting: InvoiceSortingHandler, onFilter: InvoiceFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: invoices && (_jsx(VnPagination, { currentPage: invoices?.pageNumber, totalPages: invoices?.totalPages, onPageChange: onInvoicesPageChange })) })] }) })] }));
};
export default Invoice;
